import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/siteInfo';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center transition-transform group-hover:scale-105">
              <i className="ri-star-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl md:text-2xl font-bold transition-colors ${
              isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`whitespace-nowrap text-sm font-medium transition-colors relative py-1 ${
                  location.pathname === link.href
                    ? isScrolled || !isHome
                      ? 'text-primary-600'
                      : 'text-background-50'
                    : isScrolled || !isHome
                      ? 'text-foreground-600 hover:text-foreground-900'
                      : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {link.label}
                {location.pathname === link.href && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer ${
                isScrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30 backdrop-blur-sm'
              }`}
            >
              加入我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled || !isHome
                ? 'text-foreground-900 hover:bg-background-100'
                : 'text-background-50 hover:bg-background-50/10'
            }`}
            aria-label="菜单"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-3 mt-2 rounded-lg text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              加入我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}